export default {
  data () {
    return {
      app: {
        version: process.env.VUE_APP_VERSION,
        self_url: process.env.VUE_APP_SELF_URL
      }
    }
  }
}
